/**
 * @ag-grid-community/core - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v25.3.0
 * @link http://www.ag-grid.com/
 * @license MIT
 */
var KeyName = /** @class */ (function () {
    function KeyName() {
    }
    KeyName.BACKSPACE = 'Backspace';
    KeyName.TAB = 'Tab';
    KeyName.ENTER = 'Enter';
    KeyName.SHIFT = 'Shift';
    KeyName.ESCAPE = 'Escape';
    KeyName.SPACE = ' ';
    KeyName.LEFT = 'ArrowLeft';
    KeyName.UP = 'ArrowUp';
    KeyName.RIGHT = 'ArrowRight';
    KeyName.DOWN = 'ArrowDown';
    KeyName.DELETE = 'Delete';
    // IE11 & Edge treat the numpad del key differently - with numlock on we get "Del" for key
    KeyName.NUM_PAD_DELETE = 'Del';
    KeyName.A = 'a';
    KeyName.C = 'c';
    KeyName.V = 'v';
    KeyName.D = 'd';
    KeyName.Z = 'z';
    KeyName.Y = 'y';
    KeyName.F2 = 'F2';
    KeyName.PAGE_UP = 'PageUp';
    KeyName.PAGE_DOWN = 'PageDown';
    KeyName.PAGE_HOME = 'Home';
    KeyName.PAGE_END = 'End';
    return KeyName;
}());
export { KeyName };
